import axios from 'axios'

export const getSalesList = () => {
  return axios.get('/auth/sales')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/sales.api.js